import React from 'react';
import { SettingsLayout } from '@/components/layouts';
import { SettingsCard } from '@/components/organisms/SettingsCard';
import { StaffMember } from '@/components/molecules/Settings/StaffMember';
import { PrivateLayout } from '@/components/Middleware';

const StaffMembers = () => {
  return (
    <>
      <PrivateLayout>
        <SettingsLayout hideSettingsTabPanel={true} hideHeaderRightSide={false} containerSize={'md'}>
          <SettingsCard title={'Staff Members'}>
            <StaffMember />
          </SettingsCard>
        </SettingsLayout>
      </PrivateLayout>
    </>
  );
};

export { StaffMembers };
